/**
 * PublicLayout — Shared layout for all unauthenticated public pages.
 *
 * Clean canvas with subtle dot-grid notebook texture for depth.
 */

import { Box } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { PublicFooter } from './PublicFooter';

export function PublicLayout() {
  return (
    <Box style={{ minHeight: '100vh', background: '#fafafa', color: '#1a1a1a', overflowX: 'hidden', position: 'relative' }}>

      {/* Dot-grid notebook texture */}
      <Box
        style={{
          position: 'fixed',
          inset: 0,
          pointerEvents: 'none',
          zIndex: 0,
          backgroundImage: 'radial-gradient(circle, rgba(0,0,0,.09) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
          maskImage: 'radial-gradient(ellipse 85% 75% at 50% 40%, black 25%, transparent 70%)',
          WebkitMaskImage: 'radial-gradient(ellipse 85% 75% at 50% 40%, black 25%, transparent 70%)',
        }}
      />

      <Navbar />

      <Box style={{ position: 'relative', zIndex: 1 }}>
        <Outlet />
      </Box>

      <PublicFooter />
    </Box>
  );
}
